export default {
  title: '通常の制作',
  content:
    'テンプレートをベースに新しい作品を作成し、アセットとパラメータを柔軟に調整できます。',
  dco: {
    title: 'DCO制作（Dynamic Creative Optimization）',
    content:
      'DCO制作は、広告のスマートな配信能力をサポートする制作方法で、出力される1つのパッケージで異なるコンテンツを異なるオーディエンスに表示できます。オープンされたポジションに対して選択可能なアセットを追加し、作品をSSの対応するアカウントにプッシュした後、Mintegralはアルゴリズムに基づいて各ポジションで最適なアセットを選択して組み合わせ、コンバージョンを向上させます。',
    tips: '通常、ダイナミックな広告素材を意味し、Mintegralは機械学習に基づいて素材要素を組み合わせ、広告表示を最適化し、コンバージョンを向上させます。',
  },
  multi: {
    title: '複数の組み合わせバージョン',
    content:
      '複数の組み合わせ制作は、効率的なバッチ制作方法で、同時に複数の作品をABテストできます。調整が必要な位置にアセットを追加し、すべての並べ替え組み合わせの作品を一度にダウンロードできます（最大27の組み合わせ）。',
  },
  is_optimiz: {
    label: 'スキンチェンジ制作',
    yes: 'スキンチェンジ制作をサポート',
    no: 'スキンチェンジ制作はサポートされていません',
  },
  emptyList: 'データがありません',
  previewButtonText: 'プレビュー',
  editButtonText: 'バージョンを編集',
  createButtonText: '新規プロジェクト作成',
  versionGuideText: '各バージョン',
  templateListHeaderText: {
    ProductInfo: 'クリエイティブのコンセプトID',
    VersionCount: 'バージョンの数',
    Network: 'チャネル',
    NetworkTips: '設定はMintegralチャネルのみサポートされています',
    Platform: 'プラットフォーム',
    Language: '言語',
    Lastedittime: '最終編集時間',
    Creationtime: 'プロジェクトの納期',
    versionCreatedTime: 'バージョンの作成時間',
    Options: '操作',
  },
  options: {
    version: 'バージョン管理',
    dco: 'DCOバージョン管理',
    multi: '複数の組み合わせ設定',
    preview: 'プレビュー',
    report: 'データを表示',
  },
  order: {
    ascending: '昇順',
    descending: '降順',
  },
  search: '検索',
  DatePicker: {
    Starttime: '開始時間',
    to: 'から',
    Endtime: '終了時間',
  },
  empty: {
    NoResults: '関連する結果が見つかりませんでした',
    msg: '申し訳ありませんが、条件に合致する結果は見つかりませんでした。異なる検索条件を試してみてください。',
    back: 'すべてに戻る',
    text: 'バージョンリストは空です',
    textTip: '下のボタンをクリックして、すぐに新しいバージョンを作成します',
    listEmpty: '現在のリストは空です',
    listEmptyMsg: 'このサービスはまだ利用できません。お問い合わせは',
    listEmptySubMsg: 'support@mindworks-creative.comにメールでご連絡ください',
  },
}
